<template>
  <div class="tri-manager-tab-table">
    <base-table
      :custom-fetch="customFetch"
      :columns="columns_"
      ui-pagination
      ref="baseTable"
    >
      <template #rowCheckbox="{ row }">
        <b-field>
          <b-checkbox
            :value="isChecked(row)"
            :indeterminate="isIndeterminate(row)"
            :disabled="disabled"
            @input="(value) => $emit('check', value, row)"
          />
        </b-field>
      </template>
    </base-table>
  </div>
</template>

<script>
import BaseTable from "@/components/partials/BaseTable";

/**
 * TODO - use normal table
 */
export default {
  props: {
    /**
     * Method for fetching master data
     */
    fetch: {
      required: true,
    },
    columns: {
      type: Array,
    },
    checked: {
      type: Array,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    BaseTable,
  },
  data: () => ({
    columns_: [
      {
        field: "checkbox",
        label: "",
        meta: {
          rowSlot: "rowCheckbox",
        },
      },
    ],
  }),
  mounted() {
    const columns = this.columns || [{ field: "id", label: "ID" }];
    this.columns_ = this.columns_.concat(columns);
    this.fetchData();
  },
  methods: {
    isChecked(row) {
      return !!this.checked.find((v) => v.id == row.id);
    },
    isIndeterminate(row) {
      return !!this.checked.find((v) => v.id == row.id && !!v.indeterminate);
    },
    customFetch(params) {
      return this.fetch(params);
    },
    async fetchData() {
      try {
        await this.$refs.baseTable.fetchData();
      } catch (err) {
        throw err;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Contract/ContractAssociationTable.vue